export var RichTextEditorEvents;
(function (RichTextEditorEvents) {
    RichTextEditorEvents["UPDATE_COUNT"] = "richtexteditor:update-count";
})(RichTextEditorEvents || (RichTextEditorEvents = {}));
